import { css } from '@emotion/react';
import { color, spacing, typography } from '@uniquegood/realworld-studio-design';
import { ReactNode } from 'react';

interface ConnectCardProps {
  /** 카드 상단 라벨 (예: "Realworld School") */
  eyebrow?: string;
  /** 카드 제목 (예: "스쿨 계정 연결") */
  title: string;
  /** 카드 본문 컨텐츠 */
  children: ReactNode;
}

/**
 * /connect 페이지의 카드 셸.
 *
 * 480×600 팝업 윈도우 안에서 사용된다고 가정한다.
 * - max-width 400px, 가운데 정렬
 * - min-height 360px 로 상태 전환 시 점프 방지
 * - 페이지 배경은 `color.surface_default_subdued`, 카드 배경은 `color.surface_default_default`
 */
export default function ConnectCard({ eyebrow, title, children }: ConnectCardProps) {
  return (
    <main css={styles.page}>
      <section css={styles.card} data-testid="connect-card">
        {eyebrow ? <p css={styles.eyebrow}>{eyebrow}</p> : null}
        <h1 css={styles.title}>{title}</h1>
        <div css={styles.body}>{children}</div>
      </section>
    </main>
  );
}

const styles = {
  page: css`
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${spacing.common.large};
    background: ${color.surface_default_subdued};
  `,
  card: css`
    width: 100%;
    max-width: 400px;
    min-height: 360px;
    display: flex;
    flex-direction: column;
    padding: 32px;
    border: 1px solid ${color.border_default_subdued};
    border-radius: ${spacing.borderRadius.medium};
    background: ${color.surface_default_default};
    box-shadow: 0 18px 45px rgba(25, 25, 25, 0.08);
    box-sizing: border-box;
  `,
  eyebrow: css`
    margin: 0 0 ${spacing.common.small};
    color: ${color.text_subdued};
    font-size: ${typography.size.s2};
    font-weight: ${typography.weight.medium};
  `,
  title: css`
    margin: 0;
    color: ${color.text_default};
    font-size: 24px;
    line-height: 1.3;
    font-weight: ${typography.weight.bold};
  `,
  body: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${spacing.common.medium};
    margin-top: ${spacing.common.large};
  `
};
